<template>
<v-app id="inspire">

  <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
    <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
  <v-container fluid fill-height align-start>
    <v-row v-if="activopr" justify="center" align="center" >
      <v-col md="12" lg="12" cols="12">


       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Sus codigos se generaron con éxito. Se acaban de copiar directamente en su sistema puede darles Pegar donde quieran.
       </v-alert>
        <v-alert
            :value="alertatipolista"
            color="error"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          Tiene que elegir un tipo de lista
        </v-alert>
      <v-row justify="center" align="center">
        <v-col md="8" lg="8" cols="12">
          <v-card color="#393E46">
            <v-card-title>
              Genera Codigos
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete v-model="fiestaId" :items="fiestas" placeholder="Fiesta" item-value="id" @change="dameMaximos" :item-text="item => item.nombre +' - Fecha: '+ item.fechaInicio">
                    <template v-slot:no-data>
                      <v-alert :value="true" color="error" icon="fas fa-exclamation">
                       No hay Fiesta Creada aún
                      </v-alert>
                    </template>
                  </v-autocomplete>
                <v-btn color="primary" @click="damefiestas"><v-icon>fas fa-redo</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete v-model="tipoListaId" :items="tipolistas" item-value="tipoLista.id" @change="dameMaximos" placeholder="Tipos de Lista" item-text="tipoLista.tipoListaNombre"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Cantidad Maxima :  {{cantmax.cantidadmaxima}}</p>
                  <p>Cantidad en Lista Actualmente: {{cantmax.cantidadactual}}</p>
                  <p>Posibles :{{cantmax.posibles}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col >
                  <v-text-field v-model="cantidad" :max="maximo" @change="cambiaCantidad"  type="number" label="Cantidad de Codigos" append-outer-icon="fas fa-plus" @click:append-outer="incrementNo" prepend-icon="fas fa-minus" @click:prepend="decrementNo" ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn :disabled="botn" class="primary" @click="save">Generar</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
<v-row justify="center" align="center">
  <v-col md="8" lg="8" cols="12">
    <v-card color="#393E46">
      <v-card-title>Qr's Generados</v-card-title>

      <v-card-actions>
        <v-row><v-col>Compartir</v-col></v-row>
        <v-row>
          <v-col><ShareNetwork
              network="facebook"
              :url="url"
              :title="shtitle"
              :description="shdescr"
              :quote="shquote"
              hashtags="tunay,listas"
          >
            <v-icon>fab fa-facebook</v-icon>
          </ShareNetwork></v-col>
          <v-col> <ShareNetwork
              network="whatsapp"
              :url="url"
              :title="shtitle"
              :description="shdescr"

          >
            <v-icon>fab fa-whatsapp</v-icon>
          </ShareNetwork>
          </v-col>

          <v-col> <ShareNetwork
              network="email"
              :url="url"
              :title="shtitle"
              :description="shdescr"
              hashtags="tunay,listas"
          >
            <v-icon>fas fa-envelope</v-icon>
          </ShareNetwork>
          </v-col>
        </v-row>

      </v-card-actions>

      <v-card-text>

      <v-row v-for="qr in qrs" :key="qr">
        <v-col>
          {{qr}}
        </v-col>
      </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
      </v-col>
    </v-row>
    <v-row v-else justify="center" align="center">
    <v-col md="12" lg="12" cols="12">
      ESTA DESACTIVADO COMO PROMOTOR
    </v-col>
    </v-row>
    <leftsinmenupromotor />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  <piepagina />
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftsinmenupromotor from "@/components/general/leftsinmenupromotor";
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';
import Piepagina from "@/components/general/piepagina";

export default {
  components: {
    Piepagina,
    leftsinmenupromotor,
  },
    data: () => ({
      drawer: null,
      overlay: false,
      idnegocio: 0,
      negocio: {},
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Codigos',
        disabled: true,
        alertatipolista: false,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      promotor:{},
      token:'',
      alertnuevo: false,
      alerteditar: false,
      activopr: true,
      alertatipolista:false,
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      negocitag: '',
      url:'',
      tipolistas:[],
      fiestas:[],
      qrs:[],
      botn: false,
      shtitle:'',
      shdescr:'',
      shquote:'',
      cantidad:0,
      cantmax:{
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual:'',
        posibles:''
      },
      maximo: 0,
      promotorId:0,
      txtcopia:'',
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },
      fiestaId:0,
      tipoListaId:0
  }),
  mounted (){
    this.negocitag =  this.$route.params.idnegocio;
    this.url = 'https://tunay.app/'+this.negocitag+'/codigoqr'
    if(this.usuario.id>0){
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.damepromotor();
    }else{
      this.$router.push({ path: '/' });

    }
  },

  methods : {
    damepromotor(){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("tag",this.negocitag);
      bodyFormData.append("personaId",this.usuario.id);
      axios
          .post('promotores/lista',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.promotor = response.data;
            this.activopr = this.promotor.activo
            console.log("promotor");
            console.log(this.promotor)
            this.editedItem.listaFiesta.promotor = this.promotor
            this.damefiestas()
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },
    dametipolistas(){
      this.overlay = true;
      axios
          .get('promotortipolistas/promotor/'+this.promotor.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tipolistas = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },
    cambiaCantidad(){
      if(this.cantidad > this.maximo){
        this.cantidad = this.maximo
      }
    },
    incrementNo () {
      if(this.cantidad<=this.maximo){
      this.cantidad = parseInt(this.cantidad,10) + 1}
    },
    decrementNo () {
      if(this.cantidad>0){
      this.cantidad = parseInt(this.cantidad,10) - 1
      }
    },
    damefiestas(){
      this.overlay = true
      let urlfiesta = 'promotores/fiestas';
      var bodyFormData = new FormData();

      bodyFormData.append("promotorId",this.promotor.id);

      axios
          .post(urlfiesta,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            this.overlay = false;
            this.dametipolistas()
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
    },
    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
      if (fechamax <= hoy ){
this.botn = true
      }else{
        this.botn = false
      }
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true

        axios
          .post(urlfiesta,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.cantmax = response.data;
            this.maximo = this.cantmax.posibles
            this.overlay = false;
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
      }
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    copiar(){
      this.txtcopia = ''
      this.qrs.forEach(element => this.txtcopia= this.txtcopia + element + '\r\n')

        this.$copyText(this.txtcopia)
      navigator.clipboard.writeText(this.txtcopia);
      this.shtitle = 'Qrs para Lista'
      this.shdescr = 'Los QRs:\r\n'+ this.txtcopia

    },
    save () {
      if(this.tipoListaId>0){


this.overlay = true
        var bodyFormData = new FormData();
        bodyFormData.append("promotorId",this.promotor.id);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("cantidad",this.cantidad);
        axios
      .post('lista/fiesta/qr',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
          this.qrs = response.data;
                this.alertnuevo = true;
                this.overlay = false;
                this.cantidad = 0;
                console.log(response);
                this.dameMaximos()
          this.copiar()
                })
            .catch(error => {
                    this.error = "Hubo un error";
              this.overlay = false;
                    console.log(error);
                });

      }else {
        this.alertatipolista = true
      }
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`

    ...mapGetters({
      usuario: "usuario",
      pnegocios: "pnegocios"
    })
  }
};
</script>